import { type FunctionalComponent, h } from '@stencil/core';

// This button is similar to QDS4 button
// It was created because the QDS4 button has a bug,
// when there is not enough space, the QDS button does not adjust to the width and goes beyond the viewport\

interface IConversationalSearchButton {
  text: string;
  onClick: Function;
  disabled?: boolean;
}

export const ConversationalSearchButton: FunctionalComponent<
  IConversationalSearchButton
> = (props) => (
  <button
    disabled={props.disabled ? true : false}
    class="conversational-search-button"
    onClick={() => props.onClick()}
  >
    {props.text}
  </button>
);
